import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';
import ConfirmableBtn from '@gp/components/ConfirmableBtn';
import ReportCard, { IReportCardProps } from '../ReportCard';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface IReportOperationCardProps extends IBaseProps, IReportCardProps {
  // 是否展示删除按钮，默认展示
  showDelete?: boolean;
  // 是否展示Refresh Data按钮，默认不展示
  showRefreshData?: boolean;
  // 是否禁用删除按钮，默认不禁用
  disabledDelete?: boolean;
  // 是否禁用Refresh Data按钮，默认不禁用
  disabledRefreshData?: boolean;
  // 点击删除的回调，已经经过二次确认
  onDelete?: () => void;
  // 点击Refresh Data按钮的回调
  onRefreshData?: () => void;
}

const renderHeaderRight = (props: {
  showDelete?: boolean;
  showRefreshData?: boolean;
  disabledDelete?: boolean;
  disabledRefreshData?: boolean;
  onDelete?: () => void;
  onRefreshData?: () => void;
}) => {
  const {
    showDelete = true,
    showRefreshData = false,
    disabledDelete = false,
    disabledRefreshData = false,
    onDelete,
    onRefreshData,
  } = props || {};

  const elements: React.ReactElement[] = [];
  // 删除按钮，内置了二次确认交互
  if (showDelete) {
    elements.push(
      <>
        {/* 按钮，内置了二次确认交互 */}
        <ConfirmableBtn
          key="delete"
          // 二次确认弹窗的标题
          confirmTitle="Sure to delete Project?"
          // 二次确认弹窗的描述
          confirmDescription="The deleted information will not be recovered."
          // 二次确认弹窗点击confirm的回调
          onConfirm={onDelete}
        >
          <Button
            className="dbg-dps-report-operation-card__header-operation-item"
            type="link"
            disabled={disabledDelete}
          >
            Delete
          </Button>
        </ConfirmableBtn>
      </>,
    );
  }

  // Refresh Data按钮
  if (showRefreshData) {
    elements.push(
      <>
        <Button
          key="refresh"
          className="dbg-dps-report-operation-card__header-operation-item"
          type="link"
          disabled={disabledRefreshData}
          onClick={(e) => {
            e?.stopPropagation();
            onRefreshData?.();
          }}
        >
          Refresh Data
        </Button>
      </>,
    );
  }

  if (!(elements.length > 0)) return null;
  return (
    <div className="dbg-dps-report-operation-card__header-operation dbg-dps-report-operation-card__header-operation-list">
      {elements}
    </div>
  );
};

const ReportOperationCard: React.FC<IReportOperationCardProps> = (props) => {
  const {
    className,
    showDelete = true,
    showRefreshData = false,
    disabledDelete = false,
    disabledRefreshData = false,
    onDelete,
    onRefreshData,
    ...restProps
  } = props;

  const headerRight = useMemo(
    () =>
      renderHeaderRight({ showDelete, showRefreshData, disabledDelete, disabledRefreshData, onDelete, onRefreshData }),
    [showDelete, showRefreshData, disabledDelete, disabledRefreshData, onDelete, onRefreshData],
  );

  return (
    <ReportCard
      {...restProps}
      className={classnames('dbg-dps-report-operation-card', className)}
      headerRight={headerRight}
    />
  );
};

export default ReportOperationCard;
